import React from "react";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { Tooltip, Modal, Grid, MenuItem } from "@mui/material";
import { Box } from "@mui/material";
import "../../images/namesort.png";
import "../../images/PipelineIcon.png";
import "../../images/deleteButton.png";
import { getAllSourceDestinationTypes } from "../../serviceCalls";

import axios from "axios";
import {
  successStyle,
  style,
  ErrorDiv,
  CloseImg,
  CreatePipelineHeader,
  FieldNameText,
  PipelineNameTextField,
  FieldNameSpan,
  CreatePipelineHelpIcon,
  SelectDropDown,
  SelectMenuItem,
  CreatePipelineButton,
  CheckmarkImg,
  CreateFormControl,
} from "./createPipelineStyle";
import { ProgressBar } from "../CustomProgressBar/ProgressBar";
import { appInsights } from "../../ApplicationInsightsService";
export const CreatePipelines = ({
  openCreateModal,
  setOpenCreateModal,
  pageNo,
  setPageNo,
  limit,
  totalCount,
  RequestPipelineData,
  linkedServices,
}) => {
  const { instance, accounts } = useMsal();
  const handleClose = () => setOpenCreateModal(false);
  const [pipelineName, setPipelineName] = useState("");
  const [destinationType, setDestinationType] = useState("");
  const [sourceType, setSourceType] = useState("");
  const [sourceLinkedService, setSourceLinkedService] = useState("");
  const [destinationLinkedService, setDestinationLinkedService] = useState("");
  const [scope, setScope] = useState("");
  const [fileType, setFileType] = useState("");
  const [columnDelimiter, setColumnDelimiter] = useState("");
  const [displaySuccess, setDisplaySuccess] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [displayLoading, setDisplayLoading] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [correlationId, setCorrelationId] = useState("");
  const [sourceDestinationTypeData, setSourceDestinationTypeData] = useState(
    []
  );
  useEffect(() => {
    const fetchData = async () => {
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const accessToken = await tokenResponse.accessToken;

      const sourceDestinationTypes = await getAllSourceDestinationTypes(
        accessToken
      );
      setSourceDestinationTypeData(sourceDestinationTypes.data);
    };

    fetchData();
  }, []);

  const handleSubmit = async (event) => {
    appInsights.trackEvent({
      name: `handleSubmit method called for create pipeline`,
    });
    setDisplayLoading(true);
    event.preventDefault();
    const createPipelineData = {
      PipelineName: pipelineName,
      SourceType: sourceType,
      DestinationType: destinationType,
      SourceLinkedServiceName: sourceLinkedService,
      DestinationLinkedServiceName: destinationLinkedService,
      Scope: scope,
      FileType: fileType,
      ColumnDelimiter: columnDelimiter,
    };

    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    const accessToken = await tokenResponse.accessToken;
    const createPipelineHeaders = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY}`,
      "X-OSF-Caller": `${process.env.REACT_APP_X_OSF_CALLER}`,
    };

    await axios
      .post(
        process.env.REACT_APP_API_URL + "/filetransfer/CreatePipeline",
        createPipelineData,
        {
          headers: createPipelineHeaders,
          mode: "cors",
        }
      )
      .then((response) => {
        if (response.data.StatusCode === 200) {
          handleClose();
          setDisplaySuccess(true);
          setTimeout(() => {
            const updatedPageNoOnPipelineCreate = Math.ceil(
              (totalCount + 1) / limit
            );
            setPageNo(1);
            RequestPipelineData({
              PageNo: parseInt(pageNo),
              Limit: parseInt(limit),
            });

            // if (updatedPageNoOnPipelineCreate > pageNo) {
            //   setPageNo(updatedPageNoOnPipelineCreate);
            // } else {
            //   RequestPipelineData({
            //     PageNo: parseInt(pageNo),
            //     Limit: parseInt(limit),
            //   });
            // }
            setDisplaySuccess(false);
          }, 2000);
        } else {
          setCorrelationId(response.headers["x-correlation-id"]);
          setAlertMsg(response.data.Message);
          setAlertSeverity("error");
        }
      })
      .catch((err) => {
        if (err && err.response) {
          setAlertMsg(err.message);
          setAlertSeverity("error");
          setCorrelationId(err.response.headers["x-correlation-id"]);
        }
      });
    setDisplayLoading(false);
  };

  

  return (
    <>
      {displayLoading ? (
        <ProgressBar />
      ) : (
        <>
          <div>
            <Modal
              open={openCreateModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <CloseImg
                  onClick={handleClose}
                  src={require("../../images/Close.png")}
                />
                <Box sx={{ display: "flex-inline" }}>
                  <CreatePipelineHeader>
                    <center>Create New Pipeline</center>
                  </CreatePipelineHeader>
                </Box>

                <CreateFormControl fullWidth>
                  <Grid container fullWidth>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Pipeline Name
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                    Valid Name for the pipeline based on its usage. 
                    Pipeline Name should be Unique and should not contain white spaces or special characters."
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <PipelineNameTextField
                          required
                          id="PipelineName"
                          variant="outlined"
                          size="small"
                          fullWidth
                          placeholder="Pipeline Name"
                          value={pipelineName}
                          onChange={(event) =>
                            setPipelineName(event.target.value)
                          }
                        />
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Source Type
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                    Source Type depicts the type of source location that file has to be picked from. 
                    Source type can be Cloud storage or On-prem File server location"
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="SourceType"
                          variant="outlined"
                          size="small"
                          displayEmpty
                          value={sourceType}
                          onChange={(event) => {
                            setSourceType(event.target.value);
                          }}
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          {sourceDestinationTypeData
                            .filter((item) => item.IsActive)
                            .map((item) => (
                              <MenuItem key={item.TypeId} value={item.Type}>
                                {item.Type}
                              </MenuItem>
                            ))}
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Destination Type
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                    Destination Type depicts the type of source location that file has to be picked from. 
                    Destination type can be Cloud storage or On-prem File server location"
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="DestinationType"
                          variant="outlined"
                          size="small"
                          displayEmpty
                          value={destinationType}
                          onChange={(event) =>
                            setDestinationType(event.target.value)
                          }
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          {sourceDestinationTypeData
                            .filter((item) => item.IsActive)
                            .map((item) => (
                              <MenuItem key={item.TypeId} value={item.Type}>
                                {item.Type}
                              </MenuItem>
                            ))}
                        </SelectDropDown>
                      </Box>
                    </Grid>

                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Source Linked Service
                          <FieldNameSpan
                            style={{
                              color: "var(--Warning-Red, #E52B24)",
                              "font-family": "Calibri",
                              "font-size": "20px",
                              "font-style": "normal",
                              "font-weight": "400",
                              "line-height": "normal",
                            }}
                          >
                            *
                          </FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                      A Source linked service is a connection strings, which define the connection information needed for the service to connect to external resources or data store that is the Source of data."
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="SourceLinkedServiceName"
                          variant="outlined"
                          size="small"
                          displayEmpty
                          value={sourceLinkedService}
                          onChange={(event) =>
                            setSourceLinkedService(event.target.value)
                          }
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          {linkedServices
                            .filter(
                              (item) =>
                                item.linkeServicetype !== "AzureKeyVault"
                            )
                            .map((item) => (
                              <MenuItem value={item.linkedServiceName}>
                                {item.linkedServiceName}
                              </MenuItem>
                            ))}
                          {/* <MenuItem value={"lsUpfrontOnPrem"}>
                        Upfront On Prem Linked Service
                      </MenuItem>
                      <MenuItem value={"AzureBlobStorage1"}>
                        DCP Blob Storage Linked Service
                      </MenuItem>
                      <MenuItem value={"OSFDataLakeDev"}>
                        OSF Data Lake Linked Service
                      </MenuItem> */}
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Destination Linked Service
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                      A Destination linked service is a connection strings, which define the connection information needed for the service to connect to external resources or data store that is the destination of data."
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="DestinationLinkedServiceName"
                          variant="outlined"
                          size="small"
                          value={destinationLinkedService}
                          displayEmpty
                          onChange={(event) =>
                            setDestinationLinkedService(event.target.value)
                          }
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          {linkedServices
                            .filter(
                              (item) =>
                                item.linkeServicetype !== "AzureKeyVault"
                            )
                            .map((item) => (
                              <MenuItem value={item.linkedServiceName}>
                                {item.linkedServiceName}
                              </MenuItem>
                            ))}
                          {/* <MenuItem value={"lsUpfrontOnPrem"}>
                        Upfront On Prem Linked Service
                      </MenuItem>
                      <MenuItem value={"AzureBlobStorage1"}>
                        DCP Blob Storage Linked Service
                      </MenuItem>
                      <MenuItem value={"OSFDataLakeDev"}>
                        OSF Data Lake Linked Service
                      </MenuItem> */}
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Scope
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                        <Tooltip
                          placement="right"
                          title="
                    Scope depicts the container/source to which Event Trigger should be configured"
                        >
                          <CreatePipelineHelpIcon />
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="Scope"
                          variant="outlined"
                          size="small"
                          value={scope}
                          displayEmpty
                          onChange={(event) => setScope(event.target.value)}
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          <MenuItem value={"OCC"}>OCC</MenuItem>
                          <MenuItem value={"OSFDataLake"}>OSFDataLake</MenuItem>
                          <MenuItem value={"DCP"}>DCP</MenuItem>
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          File Type
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="FileType"
                          variant="outlined"
                          size="small"
                          value={fileType}
                          displayEmpty
                          onChange={(event) => setFileType(event.target.value)}
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          <MenuItem value={"csv"}>CSV</MenuItem>
                          <MenuItem value={"txt"}>TEXT</MenuItem>
                          <MenuItem value={"json"}>JSON</MenuItem>
                          <MenuItem value={"excel"}>EXCEL</MenuItem>
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid md={4} my={0.2}>
                      <Box sx={{ display: "flex", marginTop: 2 }}>
                        <FieldNameText>
                          Column Delimiter
                          <FieldNameSpan>*</FieldNameSpan>
                        </FieldNameText>
                      </Box>
                    </Grid>
                    <Grid md={8} my={1.2}>
                      <Box>
                        <SelectDropDown
                          required
                          id="ColumnDelimiter"
                          variant="outlined"
                          size="small"
                          value={columnDelimiter}
                          displayEmpty
                          onChange={(event) =>
                            setColumnDelimiter(event.target.value)
                          }
                        >
                          <SelectMenuItem value="" disabled>
                            Select from dropdown
                          </SelectMenuItem>
                          <MenuItem value={","}>Comma(,)</MenuItem>
                          <MenuItem value={";"}>Semicolon(;)</MenuItem>
                          <MenuItem value={"|"}>Pipe(|)</MenuItem>
                          <MenuItem value={"\\t"}>Tab(\t)</MenuItem>
                          <MenuItem value={"\\u0001"}>
                            Start of the Heading(\u0001)
                          </MenuItem>
                        </SelectDropDown>
                      </Box>
                    </Grid>
                    <Grid my={3}>
                      <Box>
                        <CreatePipelineButton
                          variant="contained"
                          onClick={handleSubmit}
                        >
                          Create Pipeline
                        </CreatePipelineButton>
                      </Box>
                    </Grid>
                  </Grid>
                </CreateFormControl>
                <Box>
                  {alertMsg && (
                    <ErrorDiv severity={alertSeverity}>
                      <span>
                        {alertMsg}. Correlation Id : {correlationId}
                      </span>
                    </ErrorDiv>
                  )}
                </Box>
              </Box>
            </Modal>
          </div>
          <div>
            <Modal
              open={displaySuccess}
              onClose={() => setDisplaySuccess(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={successStyle}>
                <Box sx={{ display: "flex-inline" }}>
                  <h1>
                    <center>Pipeline Created</center>
                  </h1>
                  <CheckmarkImg
                    style={{}}
                    onClick={handleClose}
                    src={require("../../images/Checkmark.png")}
                  />
                </Box>
              </Box>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};
